// extracted by mini-css-extract-plugin
export var cardHeader = "_r6-0";
export var reorderHandle = "_r6-3";
export var titleArea = "_r6-1";
export var titleAreaWithHandle = "_r6-2";